import { DTOError } from 'src/error/errors/DTOError';
import type {
  RoomInfoFacility,
  RoomInfoImage,
  RoomInfoStateType,
} from './types';
import { initialState } from './slice';

const roomInfoImageDTO = (data: unknown): RoomInfoImage => {
  if (
    data &&
    typeof data === 'object' &&
    'x100x110' in data &&
    typeof data.x100x110 === 'string' &&
    'x150x110' in data &&
    typeof data.x150x110 === 'string' &&
    'x260x150' in data &&
    typeof data.x260x150 === 'string' &&
    'x900x380' in data &&
    typeof data.x900x380 === 'string' &&
    'x900' in data &&
    typeof data.x900 === 'string' &&
    'id' in data &&
    typeof data.id === 'number'
  ) {
    return {
      x100x110: data.x100x110,
      x150x110: data.x150x110,
      x260x150: data.x260x150,
      x900x380: data.x900x380,
      x900: data.x900,
      id: data.id,
    };
  }
  throw new DTOError('roomInfoImage', data);
};
const roomInfoFacilitiesDTO = (data: unknown): RoomInfoFacility => {
  if (
    data &&
    typeof data === 'object' &&
    'id' in data &&
    typeof data.id === 'number' &&
    'name' in data &&
    typeof data.name === 'string'
  ) {
    return {
      group_identifier:
        'group_identifier' in data && typeof data.group_identifier === 'string'
          ? data.group_identifier
          : '',
      id: data.id,
      name: data.name,
    };
  }
  throw new DTOError('roomInfoFacilitiesDTO', data);
};
export const roomInfoDTO = (data: unknown): RoomInfoStateType => {
  if (data && typeof data === 'object') {
    return {
      id: 'id' in data && typeof data.id === 'number' ? data.id : null,
      hotel_id:
        'hotel_id' in data && typeof data.hotel_id === 'number'
          ? data.hotel_id
          : null,
      room_type_id:
        'room_type_id' in data && typeof data.room_type_id === 'number'
          ? data.room_type_id
          : null,
      facilities:
        'facilities' in data && Array.isArray(data.facilities)
          ? data.facilities.map((value) => roomInfoFacilitiesDTO(value))
          : [],
      area: 'area' in data && typeof data.area === 'number' ? data.area : null,
      description:
        'description' in data && typeof data.description === 'string'
          ? data.description
          : null,
      name_ru:
        'name_ru' in data && typeof data.name_ru === 'string'
          ? data.name_ru
          : null,
      name_en:
        'name_en' in data && typeof data.name_en === 'string'
          ? data.name_en
          : null,
      images:
        'images' in data && Array.isArray(data.images)
          ? data.images.map((image) => roomInfoImageDTO(image))
          : [],
    };
  }
  return initialState;
};
